import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environments';

@Injectable({
    providedIn: 'root',
})
export class AlarmeService {
    constructor(private http: HttpClient) { }
    private apiUrl = environment.API_URL;
    private map = this.apiUrl + "ss.alarme";
    getAlertas(postos: number[] | undefined, login: string, tipoGraficoIndicador: number): Observable<any> {

        const body = {
            postos: postos,
            tipoGraficoIndicador: tipoGraficoIndicador
        };
        return this.http.post(this.map + '/getAlertas?login=' + login, body, { withCredentials: true });
    }
}
